/** Badge "N consultations" partagé entre les listes patients Professionnel et Établissement. */
export default function ConsultationsBadge({ count }: { count: number }) {
  const n = Number(count ?? 0);
  if (n <= 0) return <span className="text-[#0B1F16]/30">—</span>;
  return (
    <span className="inline-flex items-center rounded-full bg-[#00553E]/10 px-2.5 py-0.5 text-xs font-semibold text-[#00553E]">
      {n}
    </span>
  );
}
